import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Integrator } from "src/app/shared/models/integrator";
import { FocuslinkService } from "./focuslink.service";

@Injectable({
	providedIn: "root",
})
export class CommandCenterService {
	initalized: boolean = false;
	integratorList: BehaviorSubject<Integrator[]> = new BehaviorSubject<Integrator[]>([]);

	constructor(private focuslink: FocuslinkService) {}

	initCommandCenter() {
		this.integratorsGet();

		this.initalized = true;
	}

	async integratorsGet() {
		const resp = await this.focuslink.integratorsGet(true);
		this.integratorList.next(resp.map((i) => new Integrator(i)));
		return this.integratorList.value;
	}
}
